export default __webpack_public_path__ + "static/media/ServicetDeliveryManagerRole_InformationArchitecture_Thumbnaile.1948d4ff.png";